import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

// reducers
import app from './app';
import login from './login';
//import signup from './signup';
import user from './user';
import tabs from './tabs';
import forgotpassword from './forgotpassword';


// Combine reducers
export default combineReducers({
  router: routerReducer,
  app,
  login,
  //signup,
  forgotpassword,
  user,
  tabs,
});



// WEBPACK FOOTER //
// ./src/modules/index.js